var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85 3.718a.475.475 0 0 0-.312.332c-.075.269-.159.173 2.572 2.908l2.539 2.541-5.3.009c-5.262.009-5.3.009-5.414.077a.477.477 0 0 0 0 .83c.114.068.152.068 5.414.077l5.3.009-2.539 2.541c-2.114 2.117-2.544 2.562-2.571 2.666a.482.482 0 0 0 .586.587c.104-.028.62-.529 3.134-3.039 3.25-3.247 3.119-3.101 3.043-3.381-.028-.104-.535-.625-3.026-3.113-1.646-1.644-3.023-3.003-3.059-3.021a.438.438 0 0 0-.367-.023",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiArrowRight);
export default __webpack_public_path__ + "static/media/fi_arrow-right.ab093d229013e1169d314beb2d1e1dd0.svg";
export { ForwardRef as ReactComponent };